import { useTheme } from "@seneca/senekit";

import CircularBar, { CircularBarProps } from "./CircularBar";

type Props = Omit<CircularBarProps, "strokeWidth"> & {
  strokeWidth?: number;
};

const DEFAULT_STROKE_WIDTH = 12;

export type { Props };

export default function CircularProgressBar({
  progress,
  previousProgress,
  color: colorProp,
  strokeWidth = DEFAULT_STROKE_WIDTH,
  children,
  ...props
}: Props) {
  const theme = useTheme();
  const color = props.isThemed ? theme["primary-medium-content"] : colorProp;

  return (
    <CircularBar
      progress={progress! * 100}
      previousProgress={previousProgress! * 100}
      color={color}
      strokeWidth={strokeWidth}
      {...props}
    >
      {children ? children : null}
    </CircularBar>
  );
}
